import React from 'react';

export default function TimeLeft({ timeLeft }) {
  return (
    <div className="bg-blue-800/40 backdrop-blur-md rounded-2xl p-6 border border-blue-600/30">
      <div className="text-center">
        <div className="text-white text-xl font-semibold mb-2">Time left</div>
        <div className="text-6xl font-bold text-white font-mono">
          {timeLeft}
        </div>
      </div>
    </div>
  );
}